var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  fill: "#005BD1",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.4 0C5.731 0 6 0.269 6 0.6V4H9.4C9.731 4 10 4.269 10 4.6V5.4C10 5.731 9.731 6 9.4 6H6V9.4C6 9.731 5.731 10 5.4 10H4.6C4.269 10 4 9.731 4 9.4V6H0.6C0.269 6 0 5.731 0 5.4V4.6C0 4.269 0.269 4 0.6 4H4V0.6C4 0.269 4.269 0 4.6 0H5.4V0Z"
})));
export { SvgCross as ReactComponent };